import { CONFIG } from '../core/config';
import { ModelStatus } from './model-status';
import { PerformanceStandardRequirement } from './performance-standard-requirement';
import { ViewModel } from './view-model';

export class PerformanceStandard implements ViewModel {
  readonly friendlyTypeNameSingular = 'Performance Standard';
  readonly apiRoute: string = CONFIG.apiRoutes.performanceStandard;

  performanceStandardId: string;
  reference: string;
  description: string;
  scope: string;
  requirements: PerformanceStandardRequirement[];
  isSelected: boolean = false;
  status: ModelStatus = ModelStatus.Draft;

  json(): any {
    return this;
  }

  loadFromJson(data) {
    this.performanceStandardId = data.performanceStandardId;
    this.reference = data.reference;
    this.description = data.description;
    this.scope = data.scope;
    this.status = data.status;

    this.requirements = [];
    if (data.requirements) {
      this.requirements = data.requirements.map((r: PerformanceStandardRequirement) => {
        const newReq = new PerformanceStandardRequirement();
        newReq.loadFromJson(r);
        return newReq;
      });
    }
  }
}
